import { forwardRef } from 'react';

import { AccountCode } from 'core/Api';
import { Divider, Stack, Text } from 'ui';

const AccountCodesSearchableSelectItem = forwardRef<HTMLDivElement, AccountCode>(
  ({ code, name, ...others }: AccountCode, ref) => (
    <>
      <Stack ref={ref} {...others} gap="xs">
        <Text c="gray">{name}</Text>
        <Text fz={10} c="gray">
          {code}
        </Text>
      </Stack>
      <Divider />
    </>
  )
);

AccountCodesSearchableSelectItem.displayName = 'AccountCodesSearchableSelectItem';
export { AccountCodesSearchableSelectItem };
